
import { defineComponent } from 'vue'

import { EpbText } from '../shared/epb-text'

export default defineComponent({
  name: 'SemanticCard',
  components: { EpbText },
  props: {
    result: {
      type: Object,
      required: true,
    },
  },
  setup() {
    const baseClass = 'semantic-card'

    return {
      baseClass,
    }
  },
})
